module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-lincoln.e51d80b2.png";